// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"f5317d37","453":"cfa5ee6d","796":"f54add65"}[chunkId] + ".chunk.js";
};